// extracted by mini-css-extract-plugin
export default {"agenciesSummaryContainer":"AgenciesSummary_agenciesSummaryContainer__gQg+J","headerContainer":"AgenciesSummary_headerContainer__c2z8n"};